<template>
    <div class="space-y-6">
        <div
            class="pb-4 space-y-4"
            :class="[
                startSlider ? '' : 'w-full flex justify-center p-2 sm:p-6 lg:p-8 overflow-hidden',
            ]"
        >
            <SliderRow
                v-for="row in rowsWithTestimonials"
                :key="`row${row}`"
                :testimonials="testimonialsInRow(row)"
                :wall="wall"
                :style="{ width: rowWidth(row) }"
                :slideWidth="slideWidth"
                :isSlider="startSlider"
            />
        </div>
        <div class="flex justify-center" v-if="showMore">
            <button
                @click="toggleExpanded"
                :style="{
                    borderColor: wall.borderColor,
                    color: wall.titleColor,
                    'border-radius': wall.borderRadius + 'px',
                }"
                type="button"
                class="border ct-btn-sm opacity-90 hover:opacity-100"
            >
                <span> {{ expanded ? $t("r_love.show_less") : $t("r_love.show_more") }} </span>
            </button>
        </div>
    </div>
</template>

<script>
import SliderRow from "./SliderRow.vue";
export default {
    name: "Multislider",
    props: {
        wall: Object,
    },
    emits: ["updateIframe"],
    data() {
        return {
            expanded: false,
            slideWidth: 450,
            slideGap: 16,
        };
    },
    computed: {
        slidesPerView() {
            return Math.ceil(window.innerWidth / (this.slideWidth + this.slideGap));
        },
        notHidedTestimonials() {
            return this.wall.testimonials.filter((x) => !x.hide && !x._deleted && x.isPublished);
        },
        limitedTestimonials() {
            if (this.wall.maxTestimonials && !this.expanded) {
                return this.notHidedTestimonials.slice(0, this.wall.maxTestimonials);
            }
            return this.notHidedTestimonials;
        },
        testimonialsCount() {
            return this.limitedTestimonials.length;
        },
        slidesPerRow() {
            return Math.min(this.slidesPerView, this.testimonialsCount);
        },
        rowsWithTestimonials() {
            return Math.max(Math.floor(this.testimonialsCount / this.slidesPerRow), 1);
        },
        startSlider() {
            return this.slidesPerView <= this.slidesPerRow;
        },
        showMore() {
            const maxTestimonials = this.wall.maxTestimonials;
            return maxTestimonials ? this.notHidedTestimonials.length > maxTestimonials : false;
        },
    },
    components: {
        SliderRow,
    },
    methods: {
        testimonialsInRow(row) {
            const testimonials = this.singleTestimonialsInRow(row);
            if (this.startSlider) {
                return [...testimonials, ...testimonials];
            }
            return testimonials;
        },
        singleTestimonialsInRow(row) {
            if (row === this.rowsWithTestimonials) {
                return this.notHidedTestimonials.slice(
                    (row - 1) * this.slidesPerRow,
                    this.testimonialsCount
                );
            }
            return this.notHidedTestimonials.slice(
                (row - 1) * this.slidesPerRow,
                row * this.slidesPerRow
            );
        },
        rowWidth(row) {
            const testimonials = this.singleTestimonialsInRow(row);
            return `${testimonials.length * (this.slideWidth + this.slideGap)}px`;
        },
        toggleExpanded() {
            this.expanded = !this.expanded;
            this.$nextTick(() => {
                this.$emit("updateIframe");
            });
        },
    },
};
</script>

<style lang="scss">
.wall-row {
    @keyframes slideInLeft1 {
        0% {
            transform: translateX(-10%);
        }
        100% {
            transform: translateX(-110%);
        }
    }
    @keyframes slideInLeft2 {
        0% {
            transform: translateX(0%);
        }
        100% {
            transform: translateX(-100%);
        }
    }

    &:nth-child(odd) {
        animation: slideInLeft2 75s infinite linear;
    }

    &:nth-child(even) {
        animation: slideInLeft1 80s infinite linear;
    }

    &:hover {
        animation-play-state: paused;
    }

    article {
        transition: transform 0.2s ease-in-out;
    }

    article:hover {
        transform: scale(1.02);
    }
}
</style>
